import StarterKit from '@tiptap/starter-kit'
import { ChunkMark } from './editor/extensions/marks/chunk'
import { StrongMark } from './editor/extensions/marks/strong'
import { FilledPlaceholder } from './editor/extensions/nodes/filled-placeholder'
import { ListNodes } from './editor/extensions/nodes/list'

export const EDITOR_STRUCTURAL_EXTENSIONS = [
  StarterKit.configure({
    // Disabled as we use the collaboration server instead.
    undoRedo: false,

    // Disable built-in extensions that we override.
    bulletList: false,
    orderedList: false,
    listItem: false,
  }),
  ...ListNodes,
  FilledPlaceholder,
  ChunkMark,
  StrongMark,
]
